if (!customElements.get('pdp-custom')) {
  customElements.define(
    'pdp-custom',
    class ProductCssVariables extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const productData = this.getProductData();
        
        if (productData) {
          const kv = document.querySelectorAll('.ace-template .kv .kv-text');
          if (kv.length > 0) {
            const kvInfo = `<div class="product-kv-info"><span class="product-kv-info--title">${productData.name}</span><span class="product-kv-info--category">${productData.category}</span></div>`;
            kv.forEach(item => {
              const frag = document.createRange().createContextualFragment(kvInfo);
              item.insertBefore(frag, item.firstChild);
            });
          }
        }

        // Contact link
        var contactItems = document.querySelectorAll('.ace-template .how-to-use .how-to-use-item[data-opt-type="contact"]');
        if (contactItems.length > 0) {
          var customer = window.__customer__;
          var params = [];

          if (customer) {
            if (customer.first_name) params.push('First+Name=' + encodeURIComponent(customer.first_name));
            if (customer.last_name) params.push('Last+Name=' + encodeURIComponent(customer.last_name));
            if (customer.email) params.push('Email=' + encodeURIComponent(customer.email));
          }

          // Detect current locale prefix from the URL (e.g. "/de", "/fr") so the
          // link doesn't drop the visitor back to the default English store.
          var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(-[a-z]{2})?)(\/|$)/i);
          var localePrefix = localeMatch ? '/' + localeMatch[1] : '';

          var href = localePrefix + '/pages/contact-us' + (params.length > 0 ? '?' + params.join('&') : '');
          var link = document.createElement('a');
          link.href = href;

          contactItems.forEach(function (item) {
            item.appendChild(link.cloneNode(true));
          });
        }

        // Counter animation
        var DURATION = 2000;

        function parseNumber(str) {
          return Number(str.replace(/[,\\s]/g, ""));
        }

        function getDecimalPlaces(str) {
          var cleaned = str.replace(/[,\\s]/g, "");
          var dotIndex = cleaned.indexOf(".");
          return dotIndex === -1 ? 0 : cleaned.length - dotIndex - 1;
        }

        function formatNumber(num, decimals) {
          var parts = num.toFixed(decimals).split(".");
          parts[0] = Number(parts[0]).toLocaleString("ko-KR");
          return decimals > 0 ? parts[0] + "." + parts[1] : parts[0];
        }

        function easeOutExpo(t) {
          return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
        }

        function animateCounters(counterEl) {
          counterEl.querySelectorAll(".counter-item").forEach(function (item) {
            var startEl = item.querySelector(".counter-item__start");
            var goalEl = item.querySelector(".counter-item__goal");
            var suffixEl = item.querySelector(".counter-item__suffix");

            if (!startEl || !goalEl) return;

            var startValue = parseNumber(startEl.textContent);
            var goalValue = parseNumber(goalEl.textContent);
            var suffix = suffixEl ? suffixEl.textContent : "";
            var decimals = Math.max(
              getDecimalPlaces(startEl.textContent),
              getDecimalPlaces(goalEl.textContent)
            );
            var diff = goalValue - startValue;
            var startTime = null;

            function step(timestamp) {
              if (!startTime) startTime = timestamp;

              var progress = Math.min((timestamp - startTime) / DURATION, 1);
              var current = startValue + diff * easeOutExpo(progress);

              startEl.textContent = formatNumber(current, decimals);

              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                startEl.textContent = formatNumber(goalValue, decimals);
              }
            }

            requestAnimationFrame(step);
          });
        }

        function calcThreshold(el, desired) {
          var elHeight = el.getBoundingClientRect().height;
          var vpHeight = window.innerHeight;

          if (elHeight <= 0) return desired;
          return Math.min(desired, vpHeight / elHeight);
        }

        function observeWithThreshold(el, desired, callback) {
          var threshold = calcThreshold(el, desired);
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  callback(entry.target);
                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: threshold }
          );
          observer.observe(el);
        }

        document.querySelectorAll(".counter").forEach(function (el) {
          observeWithThreshold(el, 0.6, animateCounters);
        });

        document.querySelectorAll(".crossfade").forEach(function (el) {
          observeWithThreshold(el, 0.9, function (target) {
            target.classList.add("crossfade--active");
          });
        });
      }

      getProductData() {
        return {
          name: window.item && window.item.Name || document.querySelector('.product__title, h1').textContent.trim() || '',
          category: (() => {
            const categories = window.item?.Categories;
            if (!Array.isArray(categories) || categories.length === 0) return '';

            const excludedKeywords = [
              'Juicer',
              'Green Living',
              'Mind & Body',
              'Nutrition & Wellness',
              'Influencer Picks',
              'Events & Ritual Class'
            ].map(item => item.toLowerCase());

            let filtered = categories;

            if (
              categories.length >= 2 &&
              categories.some(item => excludedKeywords.includes(String(item).trim().toLowerCase()))
            ) {
              filtered = categories.filter(
                item => !excludedKeywords.includes(String(item).trim().toLowerCase())
              );
            }

            return filtered[0] || '';
          })()
        };
      }
    }
  );
}
